<template>
  <QuestionBody :qsNumber="qsNumber" :nextPage="nextPage" :navigateType="navigateType" :content="content" />
</template>

<script>
import QuestionBody from '@/layout/QuestionBody.vue'
export default {
  name: "Qs4-01",
  components: {
    QuestionBody
  },
  data() {
    return {
      qsNumber: 53,
      nextPage: '/questionnaire/section4/2',
      navigateType: 'CLICK_NEXT',
      content: {
        componentsType: {
          pc: 'labelBtn',
          mobile: 'labelBtn'
        },
        mainTitle: 'Are you allergic to any of the following caregories?',
        subTitle: 'Select all that apply.',
        btn: [
          [
            {
              text: 'Milk',
            },{
              text: 'Eggs',
            },{
              text: 'Shrimp & Crab',
            }
          ],[
            {
              text: 'Fish',
              operation: 'remove product FM-MCPEP-101'
            },{
              text: 'Peanuts',
            },{
              text: 'Soy',
              operation: 'remove product FM-CRANB-101'
            }
          ],[
            {
              text: 'Treenuts',
              operation: 'remove product FM-ELDER-101'
            },{
              text: 'Wheat',
            },{
              text: 'Aspirin',
              operation: 'remove product FM-CRANB-101'
            }
          ]
        ],
      }
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
</style>
